var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Image",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "NoPath_-_Copy",
    "data-name": "NoPath - Copy",
    width: 36,
    height: 36,
    fill: "#7367f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_21",
    "data-name": "Mask Group 21",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "__TEMP__SVG__",
    d: "M35.987,40.139h-.235C8.553,38.575,4.692,15.626,4.152,8.623a4.152,4.152,0,0,1,3.82-4.471H15.6A2.768,2.768,0,0,1,18.174,5.9l2.1,5.177a2.768,2.768,0,0,1-.609,2.99L16.72,17.039A12.969,12.969,0,0,0,27.211,27.558l3-2.976a2.768,2.768,0,0,1,3-.567l5.218,2.09a2.768,2.768,0,0,1,1.7,2.574v7.308A4.152,4.152,0,0,1,35.987,40.139ZM8.3,6.921A1.384,1.384,0,0,0,6.921,8.3v.111C7.558,16.609,11.64,35.987,35.9,37.371a1.384,1.384,0,0,0,1.468-1.3V28.679l-5.218-2.09-3.973,3.944-.664-.084C15.476,28.941,13.842,16.9,13.842,16.774l-.084-.664,3.931-3.973L15.613,6.921Z",
    transform: "translate(-4.139 -4.146)",
    fill: "#7367f0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.47606e50bb14efc71967c46619a32cd0.svg";
export { ForwardRef as ReactComponent };